export default __webpack_public_path__ + "static/media/MentoredbyTiffany-header.7ef743a0.png";